import { render } from "./Menu.vue?vue&type=template&id=459f4962&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=459f4962&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-459f4962"

export default script